// Step for choosing login method (email, Twitch)

import React from 'react';
import { AuthStepCard } from './AuthStepCard';
import { Button } from '@/components/ui/button';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import Icon from '@/components/common/Icon';
import { analyticsService } from '../../services/analyticsService';
import { initiateTwitchAuth } from '../../transport/api/publicApi';
import { markAuthCompletionPending } from '../../utilities/authCompletion';
interface ChooseMethodStepProps {
  onChooseEmail: () => void;
}

const ChooseMethodStep: React.FC<ChooseMethodStepProps> = ({
  onChooseEmail,
}) => {
  const [isTwitchSubmitting, setIsTwitchSubmitting] = React.useState(false);

  const handleTwitchLogin = () => {
    setIsTwitchSubmitting(true);
    analyticsService.trackButtonClick('Login with Twitch');
    markAuthCompletionPending();
    initiateTwitchAuth('login', { redirectTo: '/library' });
  };

  const handleEmailLogin = () => {
    analyticsService.trackButtonClick('Login with Email');
    onChooseEmail();
  };

  return (
    <AuthStepCard>
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">Choose Login Method</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <Button
          type="button"
          onClick={handleEmailLogin}
          className="w-full cursor-pointer"
          size="xl"
          disabled={isTwitchSubmitting}
        >
          Email
        </Button>
        <Button
          type="button"
          onClick={handleTwitchLogin}
          className="w-full cursor-pointer"
          size="xl"
          variant="twitch"
          disabled={isTwitchSubmitting}
        >
          <Icon name="twitch" size={20} color="#000000" hoverColor="#000000" />
          {isTwitchSubmitting ? 'Signing in...' : 'Twitch'}
        </Button>
        <Separator />
        <p className="text-center text-sm text-muted-foreground">
          You agree to our{' '}
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer text-primary underline-offset-4 hover:underline"
          >
            Terms
          </a>{' '}
          by using our service
        </p>
      </CardContent>
    </AuthStepCard>
  );
};

export default ChooseMethodStep;
